import {FC} from "react";
import {useIssueReportingChat} from "../store/useIssueReportingChat.ts";
import {useLanguage} from "../store/languageContext.ts";
import {Column} from "../atoms/Layout.tsx";
import ChatInput from "../organisms/ChatInput.tsx";
import IssueReportingChatHints from "../organisms/IssueReportingChatHints.tsx";
import ChatMessages from "../organisms/ChatMessages.tsx";
import {FeedbackPageSettings} from "../api/site.ts";

interface Props {
    siteId: string;
    settings?: FeedbackPageSettings;
}

const IssueReportingChat: FC<Props> = ({ siteId, settings }) => {
    const language = useLanguage();
    const chat = useIssueReportingChat(siteId, language.languageCode);
    const isFirstMessage = chat.messages.length === 0;

    return <Column gap="52">
        {isFirstMessage && <IssueReportingChatHints onMessage={chat.sendMessage} settings={settings} /> }
        {!isFirstMessage && <ChatMessages messages={chat.messages} waitingForResponse={chat.waitingForResponse} onStartNewChat={chat.reset} onYesNoResponse={chat.sendYesNoResponse} disableInput={chat.disableInput} siteId={siteId} /> }
        <ChatInput onChatMessage={chat.sendMessage} onUploadPhoto={chat.sendPhoto} firstMessage={isFirstMessage} disabled={chat.disableInput} />
    </Column>
}

export default IssueReportingChat